// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-tab[data-v-af44b5a6]{min-height:calc(100vh - 193px)!important}", ""]);
// Exports
module.exports = exports;
